/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdownbtn[data-v-ecfbf8cc],.dropdownbtn[data-v-ecfbf8cc]:hover{display:inline-block;margin-left:0;margin-bottom:8px;cursor:pointer;color:#333;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;border:1px solid #000;border-radius:5px;padding-bottom:9px;font-family:Montserrat Light,serif;font-size:16px;padding-top:10px}.option[data-v-ecfbf8cc]{position:relative}.value[data-v-ecfbf8cc]{font-family:Montserrat Light,serif;display:inline-block;font-size:16px;cursor:pointer;color:#6a6868}ul.drop li.active[data-v-ecfbf8cc],ul.drop li[data-v-ecfbf8cc]:hover{background-color:#ccc}.option .dropdown-pane[data-v-ecfbf8cc]{width:100%;padding:0}.dropdownbtn i[data-v-ecfbf8cc]{margin-right:25px;font-size:17px;color:#333;margin-left:8px}.drop[data-v-ecfbf8cc]{list-style-type:none;margin-bottom:0;max-height:450px;overflow-y:scroll}.drop[data-v-ecfbf8cc]::-webkit-scrollbar{opacity:0;width:0}.drop li[data-v-ecfbf8cc]{padding-left:23px;padding-top:7.5px;padding-bottom:7.5px;position:relative}.drop li a[data-v-ecfbf8cc]{color:#000;line-height:32px;padding-left:8px;width:100%;display:block;color:#313131;font-family:Montserrat,serif;font-size:14.5px}.cicloremove[data-v-ecfbf8cc]{display:none;float:left;margin-right:0;z-index:0;font-size:14px;right:10px;bottom:0;position:absolute;top:50%;transform:translateY(-100%)}.active a.opt[data-v-ecfbf8cc]{position:relative}.active .cicloremove[data-v-ecfbf8cc]{display:block;z-index:0}#grauDropDown[data-v-ecfbf8cc]{top:45px}@media (max-width:1200px){.dropdownbtn i[data-v-ecfbf8cc]{margin-right:15px;font-size:15px}.drop li[data-v-ecfbf8cc]{padding-right:20px;padding-left:20px}.drop[data-v-ecfbf8cc]{padding-top:15px;padding-bottom:20px}.drop li a[data-v-ecfbf8cc]{line-height:19px;padding-bottom:9px}.dropdownbtn[data-v-ecfbf8cc]{padding-top:11px;padding-bottom:8px}}@media (min-width:768px) and (max-width:1024px){.value[data-v-ecfbf8cc]{font-size:15px}}@media (max-width:767px){.value[data-v-ecfbf8cc]{font-size:14px}.drop li[data-v-ecfbf8cc]{padding-left:20px;padding-drop:20px;font-size:15px;padding-top:15px}.drop li a[data-v-ecfbf8cc]{line-height:18px}.drop[data-v-ecfbf8cc]{padding-top:10px;padding-bottom:25px}.dropdownbtn[data-v-ecfbf8cc],.dropdownbtn[data-v-ecfbf8cc]:hover{font-family:Montserrat Light,serif;font-size:14px;padding-top:10px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img[data-v-2e139230]{display:block;border-radius:50%;width:40px;height:40px;background:#b1b1b1 50%;margin-right:5%}h1[data-v-2e139230]{font-family:Montserrat Light,serif;font-size:140px;position:absolute;line-height:1;top:0}p[data-v-2e139230]{font-family:Montserrat,serif;color:#454648;padding-bottom:0}h2[data-v-2e139230],p[data-v-2e139230]{font-size:15px}h2[data-v-2e139230]{font-family:Montserrat Semibold,serif;margin-bottom:0;letter-spacing:normal}.wrapper[data-v-2e139230]{position:relative;display:flex;flex-direction:column;background-color:#fff;margin-bottom:12px;border-radius:7px;padding:60px 40px 28px 50px;box-shadow:2px 4px 17px -8px #928888ba}.person[data-v-2e139230]{display:flex;align-items:center}@media (max-width:1440px){h2[data-v-2e139230]{font-size:15px}}@media (max-width:1220px){p[data-v-2e139230]{line-height:1.5;margin-bottom:2px}h2[data-v-2e139230]{line-height:1.2}h1[data-v-2e139230]{font-size:100px;top:10px}.wrapper[data-v-2e139230]{padding-top:53px}}@media (max-width:1023px){.wrapper[data-v-2e139230]{padding-right:15px}h2[data-v-2e139230]{padding-top:0;font-size:14px;margin-bottom:0}img[data-v-2e139230]{width:33px;height:33px}p[data-v-2e139230]{margin-right:20px;margin-left:0;padding-left:0}}@media (max-width:767px){.person[data-v-2e139230]{padding-top:5px}p[data-v-2e139230]{padding-right:15px;font-size:13px;height:auto;margin-bottom:0}h1[data-v-2e139230]{font-size:90px}h2[data-v-2e139230]{font-size:13px;line-height:15px}.wrapper[data-v-2e139230]{padding:40px 10px 25px 35px}.wrapper p[data-v-2e139230]{margin-top:10px;margin-bottom:15px;margin-right:0}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".botao_style[data-v-0a20cc1c]{background-color:transparent;width:280px;border-radius:4px;border:2px solid var(--50815640);display:inline-block}.botao_style p[data-v-0a20cc1c]{font-family:Montserrat;font-size:16px;padding:10px;text-align:center;color:var(--66740a82);margin-bottom:0}.botao_style[data-v-0a20cc1c]:hover{background-color:var(--50610ec4);cursor:pointer}.botao_style:hover>p[data-v-0a20cc1c]{color:#fff}@media (max-width:1025px){.botao_style p[data-v-0a20cc1c]{font-size:15px;padding:9px}}@media (max-width:767px){.botao_style[data-v-0a20cc1c]{width:100%}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, "nav[data-v-fdffc126]{display:block}.breadcrumbs[data-v-fdffc126]{display:flex;flex-direction:row;justify-content:flex-start;white-space:nowrap}.breadcrumbs li[data-v-fdffc126]{font-size:15px;font-family:Montserrat;text-transform:none}.onviewportnotranslate[data-v-fdffc126]{opacity:1!important;transition-property:opacity,transform;transition-duration:.8s,1s;transition-timing-function:ease-in,ease-in;transition-delay:.2s,.2s}li[data-v-fdffc126]{opacity:0;transition-delay:.2s}li+li[data-v-fdffc126]{transition-delay:.4s}li+li+li[data-v-fdffc126]{transition-delay:.6s}li+li+li+li[data-v-fdffc126]{transition-delay:.8s}li+li+li+li+li[data-v-fdffc126]{transition-delay:1s}[v-cloak][data-v-fdffc126]{display:none}.breadcrumbs a[data-v-fdffc126]{color:#a7a5a5}.breadcrumbs a[data-v-fdffc126]:hover{color:#c9c7c7;text-decoration:none}@media (min-width:768px) and (max-width:1024px){.breadcrumbs li[data-v-fdffc126]{font-size:14px}}@media (max-width:767px){nav[data-v-fdffc126]{display:none}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 701:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dots[data-v-0912873e]{display:flex;flex-direction:row;justify-content:center;margin-top:35px}.dot[data-v-0912873e]{width:12px;height:12px;border-radius:50%;border:1px;background-color:rgba(0,0,0,.16);margin-right:7px;margin-left:7px}.dot[data-v-0912873e]:not(.active):hover{cursor:pointer;background-color:rgba(0,0,0,.24)}.dot.active[data-v-0912873e]{background-color:rgba(0,0,0,.56)}@media only screen and (max-width:767px){.dots.lots[data-v-0912873e]{display:none}}.dot.artes-e-humanidades[data-v-0912873e]{background:#4646a5}.dot.ciencias-exatas-e-da-engenharia[data-v-0912873e]{background:#87cefa}.dot.ciencias-sociais[data-v-0912873e]{background:#761818}.dot.ciencias-da-vida[data-v-0912873e]{background:orange}.dot.escola-superior-de-saude[data-v-0912873e]{background:#04b671}.dot.escola-superior-de-tecnologia-e-gestao[data-v-0912873e]{background:#f1a308}.dot.artes-e-humanidades[data-v-0912873e]:hover{background:#d2d2e7}.dot.ciencias-exatas-e-da-engenharia[data-v-0912873e]:hover{background:#bdd2e0}.dot.ciencias-sociais[data-v-0912873e]:hover{background:#f8e1db}.dot.ciencias-da-vida[data-v-0912873e]:hover{background:#e1c2ae}.dot.escola-superior-de-saude[data-v-0912873e]:hover{background:#d3f9ea}.dot.escola-superior-de-tecnologia-e-gestao[data-v-0912873e]:hover{background:#fc6}.dot.artes-e-humanidades.active[data-v-0912873e]{background:#6a6acb}.dot.ciencias-exatas-e-da-engenharia.active[data-v-0912873e]{background:#087bc2}.dot.ciencias-sociais.active[data-v-0912873e]{background:#c63a3a}.dot.ciencias-da-vida.active[data-v-0912873e]{background:#e87b34}.dot.escola-superior-de-saude.active[data-v-0912873e]{background:#41bb8c}.dot.escola-superior-de-tecnologia-e-gestao.active[data-v-0912873e]{background:#e29f19}@media(max-width:767px){.dot[data-v-0912873e]{margin-left:11px;margin-right:11px;width:10px;height:10px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 908:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".botao[data-v-a48fe9c8]{position:absolute;top:50%;transform:translateY(-50%);width:40px;height:40px;background:transparent;color:#fff;z-index:3;border-radius:50%}.botao.next[data-v-a48fe9c8]{right:5%}.botao.previous[data-v-a48fe9c8]{left:5%}.botao i[data-v-a48fe9c8]{width:40px;height:40px;font-size:20px;line-height:40px;text-align:center}.botao i[data-v-a48fe9c8],a.botao:hover i[data-v-a48fe9c8]{color:#fff}@media only screen and (max-width:1380px){.testemunhoItem[data-v-a48fe9c8]{margin-bottom:35px}.botao.previous[data-v-a48fe9c8]{top:47%;left:4%}.botao.next[data-v-a48fe9c8]{top:47%;right:4%}}@media only screen and (max-width:1000px){.testemunhoItem[data-v-a48fe9c8]{margin-bottom:5px}.botao[data-v-a48fe9c8],.botao i[data-v-a48fe9c8]{width:30px;height:30px}.botao i[data-v-a48fe9c8]{font-size:14px;line-height:30px}}@media only screen and (max-width:767px){.botao[data-v-a48fe9c8]{width:33px;height:33px}.botao.previous[data-v-a48fe9c8]{left:2%}.botao.next[data-v-a48fe9c8]{right:2%}.botao i[data-v-a48fe9c8]{width:33px;height:33px;font-size:15px;line-height:33px}}.botao.artes-e-humanidades[data-v-a48fe9c8]{background:#6a6acb}.botao.ciencias-exatas-e-da-engenharia[data-v-a48fe9c8]{background:#087bc2}.botao.ciencias-sociais[data-v-a48fe9c8]{background:#c63a3a}.botao.ciencias-da-vida[data-v-a48fe9c8]{background:#e87b34}.botao.escola-superior-de-saude[data-v-a48fe9c8]{background:#41bb8c}.botao.escola-superior-de-tecnologia-e-gestao[data-v-a48fe9c8]{background:#e29f19}a.botao.artes-e-humanidades[data-v-a48fe9c8]:hover{background:#4646a5}a.botao.ciencias-exatas-e-da-engenharia[data-v-a48fe9c8]:hover{background:#87cefa}a.botao.ciencias-sociais[data-v-a48fe9c8]:hover{background:#761818}a.botao.ciencias-da-vida[data-v-a48fe9c8]:hover{background:orange}a.botao.escola-superior-de-saude[data-v-a48fe9c8]:hover{background:#04b671}a.botao.escola-superior-de-tecnologia-e-gestao[data-v-a48fe9c8]:hover{background:#f1a308}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony import */ var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".row[data-v-61b291c1]{max-width:100%}.cursorStyle[data-v-61b291c1]{cursor:move}.casosslider[data-v-61b291c1]{cursor:pointer;transition:transform 1s cubic-bezier(.645,.045,.355,1) 0s}.casosslider.drag[data-v-61b291c1]{transition:transform 0s}.row .row[data-v-61b291c1]{margin-right:0;margin-left:0}.paddingwrapper[data-v-61b291c1]{padding-left:10%;padding-right:10%;position:relative}.hiddenwrapper[data-v-61b291c1]{overflow-x:hidden}.row.casosslider[data-v-61b291c1]{margin:0;padding:0;position:relative}.row.casosslider>.columns[data-v-61b291c1]{padding-left:0;padding-right:0}.testemunho[data-v-61b291c1]{position:absolute;top:0;bottom:0;left:0;right:0}.testemunhoItem.artes-e-humanidades[data-v-61b291c1]{color:#6a6acb}.testemunhoItem.ciencias-exatas-e-da-engenharia[data-v-61b291c1]{color:#087bc2}.testemunhoItem.ciencias-sociais[data-v-61b291c1]{color:#c63a3a}.testemunhoItem.ciencias-da-vida[data-v-61b291c1]{color:#e87b34}.testemunhoItem.escola-superior-de-saude[data-v-61b291c1]{color:#41bb8c}.testemunhoItem.escola-superior-de-tecnologia-e-gestao[data-v-61b291c1]{color:#e29f19}.slidewrapper .columns[data-v-61b291c1]{padding-right:.5rem;padding-left:.5rem}.testemunhoItem[data-v-61b291c1]:hover{box-shadow:2px 4px 17px -6px rgba(16,13,13,.729)}@media only screen and (max-width:1380px){.testemunhoItem[data-v-61b291c1]{margin-bottom:35px}.dots[data-v-61b291c1]{margin-top:5px}}@media only screen and (max-width:1000px){.slidewrapper .columns[data-v-61b291c1]{padding-right:20px;padding-left:20px}}@media(max-width:767px){.testemunhoItem[data-v-61b291c1]{margin-bottom:25px}}", ""]);
// Exports
/* harmony default export */ __webpack_exports__["default"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 645:
/***/ (function(module) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";

      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }

      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }

      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }

      content += cssWithMappingToString(item);

      if (needLayer) {
        content += "}";
      }

      if (item[2]) {
        content += "}";
      }

      if (item[4]) {
        content += "}";
      }

      return content;
    }).join("");
  }; // import a list of modules into the list


  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }

      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }

      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }

      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ }),

/***/ 81:
/***/ (function(module) {

"use strict";


module.exports = function (i) {
  return i[1];
};

/***/ }),

/***/ 89:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
}); // runtime helper for setting properties on components
// in a tree-shakable way

exports.Z = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;

  for (const [key, val] of props) {
    target[key] = val;
  }

  return target;
};

/***/ }),

/***/ 629:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(478);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(37)/* ["default"] */ .Z)
var update = add("142b7907", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(221);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(37)/* ["default"] */ .Z)
var update = add("7112f77c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 660:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(531);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(37)/* ["default"] */ .Z)
var update = add("056e8dfe", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 975:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(24);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(37)/* ["default"] */ .Z)
var update = add("1556d069", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(701);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(37)/* ["default"] */ .Z)
var update = add("7afc551c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(908);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(37)/* ["default"] */ .Z)
var update = add("43ae4041", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 745:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(665);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = (__webpack_require__(37)/* ["default"] */ .Z)
var update = add("536a737c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ 37:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ addStylesClient; }
});

;// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles(parentId, list) {
  var styles = [];
  var newStyles = {};

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = item[0];
    var css = item[1];
    var media = item[2];
    var sourceMap = item[3];
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    };

    if (!newStyles[id]) {
      styles.push(newStyles[id] = {
        id: id,
        parts: [part]
      });
    } else {
      newStyles[id].parts.push(part);
    }
  }

  return styles;
}
;// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BreadCrumb": function() { return /* reexport */ BreadCrumb; },
  "Combobox": function() { return /* reexport */ ComboBox; },
  "TBotao": function() { return /* reexport */ TBotao; },
  "WebSlider": function() { return /* reexport */ WebSlider; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject = require("vue");
;// CONCATENATED MODULE: ./src/assets/dragimagev1.png
var dragimagev1_namespaceObject = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAAaADAAQAAAABAAAAAQAAAAD5Ip3+AAAAC0lEQVQIHWNgAAIAAAUAAY27m/MAAAAASUVORK5CYII=";
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/WebSlider.vue?vue&type=template&id=61b291c1&scoped=true



const _withScopeId = n => ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.pushScopeId)("data-v-61b291c1"), n = n(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.popScopeId)(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("img", {
  src: dragimagev1_namespaceObject,
  id: "dragimage"
}, null, -1));

const _hoisted_2 = ["onDragstart"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SliderNavigation = (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.resolveComponent)("SliderNavigation");

  const _component_TestemunhoRow = (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.resolveComponent)("TestemunhoRow");

  const _component_SliderDots = (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.resolveComponent)("SliderDots");

  const _directive_resize = (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.resolveDirective)("resize");

  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Fragment, null, [_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("div", {
    onDragover: _cache[4] || (_cache[4] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withModifiers)(() => {}, ["prevent"])),
    onDragenter: _cache[5] || (_cache[5] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withModifiers)(() => {}, ["prevent"])),
    onDrop: _cache[6] || (_cache[6] = (...args) => $options.onDrop && $options.onDrop(...args)),
    class: "paddingwrapper",
    id: "stage"
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createVNode)(_component_SliderNavigation, {
    onSlideBack: $options.slideBack,
    onSlideNext: $options.slideNext,
    className: $data.slides[0].elements[0].Faculdade.name,
    showNavigation: this.slides.length > 1
  }, null, 8, ["onSlideBack", "onSlideNext", "className", "showNavigation"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("div", {
    class: "hiddenwrapper",
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeStyle)({
      height: `${$data.slideHeight}px`
    })
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)(["row casosslider", {
      'drag': $data.isDragging
    }]),
    style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeStyle)({
      transform: `translateX(${$data.slideWrapperPosition}px)`
    })
  }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.renderList)($data.slides, (slide, index) => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("div", {
      key: index,
      style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeStyle)({
        transform: `translateX(${slide.position}px)`
      }),
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)(["small-12 medium-12 large-12 columns testemunho", {
        'active': index == $data.currentSlide
      }])
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("div", {
      class: "row slidewrapper",
      onDrag: _cache[0] || (_cache[0] = (...args) => $options.dragSlide && $options.dragSlide(...args)),
      onDragstart: $event => $options.startDrag($event, slide),
      draggable: "true",
      onTouchstartPassive: _cache[1] || (_cache[1] = (...args) => $options.onTouchStart && $options.onTouchStart(...args)),
      onTouchmovePassive: _cache[2] || (_cache[2] = (...args) => $options.onTouchMove && $options.onTouchMove(...args)),
      onTouchendPassive: _cache[3] || (_cache[3] = (...args) => $options.onTouchEnd && $options.onTouchEnd(...args)),
      ref_for: true,
      ref: `sld${index}`
    }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.renderList)(slide.elements, (testemunho, index2) => {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("div", {
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)(["columns small-4", {
          'small-6': $data.elementsPerSlide === 2,
          'small-12': $data.elementsPerSlide === 1
        }]),
        key: testemunho.ID
      }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createBlock)(_component_TestemunhoRow, {
        onClick: $event => $options.changeTestemunho(testemunho),
        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)(["testemunhoItem", testemunho.Faculdade.name]),
        nome: testemunho.Identificacao,
        depoimento: testemunho.Depoimento,
        curso: testemunho.Curso.post_title,
        imagem: testemunho.Imagem,
        key: index2
      }, null, 8, ["onClick", "class", "nome", "depoimento", "curso", "imagem"]))], 2);
    }), 128))], 40, _hoisted_2)], 6);
  }), 128))], 6)), [[_directive_resize, $options.setDimensions]])], 4)], 32), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createVNode)(_component_SliderDots, {
    onClickedDot: $options.changePage,
    numberOfDots: this.slides.length,
    showDots: this.slides.length > 1,
    currentSlideIndex: $data.currentSlideIndex,
    colorClass: $data.colorClass
  }, null, 8, ["onClickedDot", "numberOfDots", "showDots", "currentSlideIndex", "colorClass"])], 64);
}
;// CONCATENATED MODULE: ./src/components/WebSlider.vue?vue&type=template&id=61b291c1&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/TestemunhoRow.vue?vue&type=template&id=2e139230&scoped=true


const TestemunhoRowvue_type_template_id_2e139230_scoped_true_withScopeId = n => ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.pushScopeId)("data-v-2e139230"), n = n(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.popScopeId)(), n);

const TestemunhoRowvue_type_template_id_2e139230_scoped_true_hoisted_1 = {
  class: "wrapper"
};

const TestemunhoRowvue_type_template_id_2e139230_scoped_true_hoisted_2 = /*#__PURE__*/TestemunhoRowvue_type_template_id_2e139230_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("h1", null, "“", -1));

const _hoisted_3 = {
  class: "person"
};
const _hoisted_4 = ["src"];
function TestemunhoRowvue_type_template_id_2e139230_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("div", TestemunhoRowvue_type_template_id_2e139230_scoped_true_hoisted_1, [TestemunhoRowvue_type_template_id_2e139230_scoped_true_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)($props.depoimento), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("div", _hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("img", {
    src: $props.imagem
  }, null, 8, _hoisted_4), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("h2", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)($props.nome) + " - " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)($props.curso), 1)])]);
}
;// CONCATENATED MODULE: ./src/components/TestemunhoRow.vue?vue&type=template&id=2e139230&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/TestemunhoRow.vue?vue&type=script&lang=js
/* harmony default export */ var TestemunhoRowvue_type_script_lang_js = ({
  name: "TestemunhoRow",
  props: ["nome", "depoimento", "curso", "imagem"]
});
;// CONCATENATED MODULE: ./src/components/TestemunhoRow.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/TestemunhoRow.vue?vue&type=style&index=0&id=2e139230&scoped=true&lang=css
var TestemunhoRowvue_type_style_index_0_id_2e139230_scoped_true_lang_css = __webpack_require__(148);
;// CONCATENATED MODULE: ./src/components/TestemunhoRow.vue?vue&type=style&index=0&id=2e139230&scoped=true&lang=css

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(89);
;// CONCATENATED MODULE: ./src/components/TestemunhoRow.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TestemunhoRowvue_type_script_lang_js, [['render',TestemunhoRowvue_type_template_id_2e139230_scoped_true_render],['__scopeId',"data-v-2e139230"]])

/* harmony default export */ var TestemunhoRow = (__exports__);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/SliderDots.vue?vue&type=template&id=0912873e&scoped=true


const SliderDotsvue_type_template_id_0912873e_scoped_true_withScopeId = n => (_pushScopeId("data-v-0912873e"), n = n(), _popScopeId(), n);

const SliderDotsvue_type_template_id_0912873e_scoped_true_hoisted_1 = ["onClick"];
function SliderDotsvue_type_template_id_0912873e_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.numberOfDots > 1 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("div", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)(["dots", {
      'lots': $props.numberOfDots > 9
    }])
  }, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.renderList)($props.numberOfDots, index => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("div", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)(["dot", [{
        'active': index == $props.currentSlideIndex + 1
      }, $props.colorClass]]),
      onClick: $event => $options.changePage(index),
      key: index
    }, null, 10, SliderDotsvue_type_template_id_0912873e_scoped_true_hoisted_1);
  }), 128))], 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createCommentVNode)("", true);
}
;// CONCATENATED MODULE: ./src/components/SliderDots.vue?vue&type=template&id=0912873e&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/SliderDots.vue?vue&type=script&lang=js
/* harmony default export */ var SliderDotsvue_type_script_lang_js = ({
  props: ["numberOfDots", "showDots", "currentSlideIndex", "colorClass"],
  emits: ['clickedDot'],
  methods: {
    changePage(index) {
      this.$emit("clickedDot", index - 1);
    }

  }
});
;// CONCATENATED MODULE: ./src/components/SliderDots.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/SliderDots.vue?vue&type=style&index=0&id=0912873e&lang=scss&scoped=true
var SliderDotsvue_type_style_index_0_id_0912873e_lang_scss_scoped_true = __webpack_require__(652);
;// CONCATENATED MODULE: ./src/components/SliderDots.vue?vue&type=style&index=0&id=0912873e&lang=scss&scoped=true

;// CONCATENATED MODULE: ./src/components/SliderDots.vue




;


const SliderDots_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SliderDotsvue_type_script_lang_js, [['render',SliderDotsvue_type_template_id_0912873e_scoped_true_render],['__scopeId',"data-v-0912873e"]])

/* harmony default export */ var SliderDots = (SliderDots_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/SliderNavigation.vue?vue&type=template&id=a48fe9c8&scoped=true


const SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_withScopeId = n => ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.pushScopeId)("data-v-a48fe9c8"), n = n(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.popScopeId)(), n);

const SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_hoisted_1 = /*#__PURE__*/SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("i", {
  class: "chev i ms-Icon ms-Icon--ChevronRight"
}, null, -1));

const SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_hoisted_2 = [SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_hoisted_1];

const SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_hoisted_3 = /*#__PURE__*/SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("i", {
  class: "chev i ms-Icon ms-Icon--ChevronLeft"
}, null, -1));

const SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_hoisted_4 = [SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_hoisted_3];
function SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Fragment, null, [$props.showNavigation ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("a", {
    key: 0,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)(["botao next", $props.className]),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('slideNext'))
  }, SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_hoisted_2, 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createCommentVNode)("", true), $props.showNavigation ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("a", {
    key: 1,
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)(["botao previous", $props.className]),
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('slideBack'))
  }, SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_hoisted_4, 2)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createCommentVNode)("", true)], 64);
}
;// CONCATENATED MODULE: ./src/components/SliderNavigation.vue?vue&type=template&id=a48fe9c8&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/SliderNavigation.vue?vue&type=script&lang=js
/* harmony default export */ var SliderNavigationvue_type_script_lang_js = ({
  props: ["className", "showNavigation"],
  emits: ["slideNext", "slideBack"]
});
;// CONCATENATED MODULE: ./src/components/SliderNavigation.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/SliderNavigation.vue?vue&type=style&index=0&id=a48fe9c8&scoped=true&lang=scss
var SliderNavigationvue_type_style_index_0_id_a48fe9c8_scoped_true_lang_scss = __webpack_require__(557);
;// CONCATENATED MODULE: ./src/components/SliderNavigation.vue?vue&type=style&index=0&id=a48fe9c8&scoped=true&lang=scss

;// CONCATENATED MODULE: ./src/components/SliderNavigation.vue




;


const SliderNavigation_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(SliderNavigationvue_type_script_lang_js, [['render',SliderNavigationvue_type_template_id_a48fe9c8_scoped_true_render],['__scopeId',"data-v-a48fe9c8"]])

/* harmony default export */ var SliderNavigation = (SliderNavigation_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/WebSlider.vue?vue&type=script&lang=js



const resize = {
  beforeMount: (el, binding) => {
    const onResizeCallback = binding.value;
    window.addEventListener("resize", () => {
      const items = Array.from(document.querySelectorAll(".testemunho .slidewrapper"));
      const defaultHeight = Math.max(...items.map(el1 => el1.offsetHeight));
      onResizeCallback(defaultHeight);
    });
  },

  updated(el, binding) {
    const onResizeCallback = binding.value;
    const items = Array.from(document.querySelectorAll(".testemunho .slidewrapper"));
    const defaultHeight = Math.max(...items.map(el1 => el1.offsetHeight));
    onResizeCallback(defaultHeight);
  },

  unmounted: el => {
    document.removeEventListener("resize", el.resize);
  }
};
const paddingOfAppWrapp = 0.1 * 2;
const w = document.getElementById("app").offsetWidth;
const wl = w - w * paddingOfAppWrapp;
let sliderWidth = wl;
const IPADWIDTH = 1280;
const IPHONEWIDTH = 900;
/* harmony default export */ var WebSlidervue_type_script_lang_js = ({
  name: "WebSlider",
  props: ["items"],
  emits: ["slideItemClicked"],
  components: {
    TestemunhoRow: TestemunhoRow,
    SliderDots: SliderDots,
    SliderNavigation: SliderNavigation
  },

  data() {
    return {
      resizeObserver: null,
      currentSlideIndex: 0,
      currentSlide: null,
      slides: [],
      slideHeight: 0,
      startPoint: 0,
      sliderWidth: sliderWidth,
      elementsPerSlide: 3,
      isDragging: false,
      slideWrapperPosition: 0,
      colorClass: "",
      isSliding: false
    };
  },

  computed: {
    nextSlideIndex() {
      const slidesLength = this.slides.length - 1;
      return this.currentSlideIndex == slidesLength ? 0 : this.currentSlideIndex + 1;
    },

    previousSlideIndex() {
      return this.currentSlideIndex == 0 ? this.slides.length - 1 : this.currentSlideIndex - 1;
    },

    currentSlidePosition() {
      return this.slides[this.currentSlideIndex].position;
    },

    previousSlidePosition() {
      return this.slides[this.previousSlideIndex].position;
    },

    nextSlidePosition() {
      return this.slides[this.nextSlideIndex].position;
    }

  },

  created() {
    this.colorClass = this.items[0]?.Faculdade.name;
    this.setNumberOfElementsOnSlides();
    this.initSlides();
  },

  mounted() {
    this.resizeObserver = new ResizeObserver(() => {
      this.equalizeSlidesHeight();
    });
    this.resizeObserver.observe(this.$refs.sld0[0]);
    window.addEventListener("resize", () => {
      const numberOfCurrentSlides = this.slides.length;
      const currentIndex = this.currentSlideIndex;
      this.setNumberOfElementsPerSlide();

      if (this.slides.length != numberOfCurrentSlides) {
        this.currentSlideIndex = this.getUpdatedIndex(currentIndex, this.elementsPerSlide);
      }

      this.moveSlide(-this.currentSlidePosition);
    });
    const el = document.querySelector(".casosslider");
    el.addEventListener('transitionstart', () => {
      this.isSliding = true;
    });
    el.addEventListener('transitionend', () => {
      this.isSliding = false;

      if (this.needsToRecalculateSlidePosition()) {
        this.recalculatePreviousSlidePosition();
      }
    });
    this.setSlidesPosition();
    this.equalizeSlidesHeight();
  },

  unmounted() {
    this.resizeObserver = null;
    window.removeEventListener("resize", window);
  },

  methods: {
    changePage(index) {
      if (this.currentSlideIndex < index) {
        const diff = index - this.currentSlideIndex;

        for (let i = 0; i < diff; i++) {
          this.slideNext();
        }
      } else {
        const diff = this.currentSlideIndex - index;

        for (let i = 0; i < diff; i++) {
          this.slideBack();
        }
      }
    },

    onTouchStart(evt) {
      if (this.slides.length > 1) {
        this.isDragging = true;
        this.startPoint = evt.changedTouches[0].clientX;
      } else {
        evt.preventDefault();
      }
    },

    onTouchMove(evt) {
      const tc = evt.changedTouches[0].clientX;

      if (this.isDraggingToRight(tc)) {
        this.dragSlideToRight(tc);
      } else {
        this.dragSlideToleft(tc);
      }
    },

    onTouchEnd(evt) {
      this.isDragging = false;
      const pageX = evt.changedTouches[0].clientX;
      let deltaPageX = pageX - this.startPoint;

      if (deltaPageX > 0) {
        if (this.shouldGoToPreviousSlide()) {
          this.slideBack();
        } else {
          this.moveSlide(-this.currentSlidePosition);
        }
      } else {
        if (this.shouldGoToNextSlide()) {
          this.slideNext();
        } else {
          this.moveSlide(-this.currentSlidePosition);
        }
      }
    },

    startDrag(evt, item) {
      if (this.slides.length > 1) {
        this.isDragging = true;
        evt.dataTransfer.dropEffect = "none";
        evt.dataTransfer.effectAllowed = "move";
        const img = document.getElementById("dragimage");
        evt.dataTransfer.setDragImage(img, 0, 0);
        evt.dataTransfer.setData('itemID', item.position);
        this.startPoint = evt.pageX;
      } else {
        evt.preventDefault();
      }
    },

    onDrop(evt) {
      this.isDragging = false;
      let deltaPageX = evt.pageX - this.startPoint;

      if (deltaPageX > 0) {
        if (this.shouldGoToPreviousSlide()) {
          this.slideBack();
        } else {
          this.moveSlide(-this.currentSlidePosition);
        }
      } else {
        if (this.shouldGoToNextSlide()) {
          this.slideNext();
        } else {
          this.moveSlide(-this.currentSlidePosition);
        }
      }
    },

    dragSlide(ev) {
      let {
        pageX
      } = ev;

      if (this.isDraggingToRight(pageX)) {
        this.dragSlideToRight(pageX);
      } else {
        this.dragSlideToleft(pageX);
      }
    },

    isDraggingToRight(pageX) {
      return pageX - this.startPoint > 0;
    },

    dragSlideToleft(pageX) {
      let deltaX = pageX - this.startPoint;
      this.beforeSlideNextCheckAndUpdatePosition();

      if (this.currentSlidePosition > 0) {
        this.moveSlide(-(this.currentSlidePosition - deltaX));
      } else {
        let updatedSlidePosition = this.currentSlidePosition >= 0 ? this.currentSlidePosition + deltaX : Math.abs(this.currentSlidePosition - deltaX);
        this.moveSlide(updatedSlidePosition);
      }
    },

    dragSlideToRight(pageX) {
      let deltaX = pageX - this.startPoint;
      this.beforeSlideBackCheckAndUpdatePosition();

      if (this.currentSlidePosition > 0) {
        this.moveSlide(-(this.currentSlidePosition - deltaX));
      } else {
        let updatedSlidePosition = Math.abs(this.currentSlidePosition - deltaX);
        this.moveSlide(updatedSlidePosition);
      }
    },

    beforeSlideNextCheckAndUpdatePosition() {
      if (this.nextSlidePosition < this.currentSlidePosition) {
        this.slides[this.nextSlideIndex].position = this.currentSlidePosition + sliderWidth;
      }
    },

    beforeSlideBackCheckAndUpdatePosition() {
      if (this.previousSlidePosition > this.currentSlidePosition) {
        this.slides[this.previousSlideIndex].position = this.currentSlidePosition - sliderWidth;
      }
    },

    shouldGoToNextSlide() {
      const distanceToCurrentSlidePosition = Math.abs(Math.abs(this.currentSlidePosition) - Math.abs(this.slideWrapperPosition));
      const distanceToNextSlide = Math.abs(Math.abs(this.nextSlidePosition) - Math.abs(this.slideWrapperPosition));
      return distanceToNextSlide < distanceToCurrentSlidePosition;
    },

    shouldGoToPreviousSlide() {
      const distanceToCurrentSlidePosition = Math.abs(Math.abs(this.currentSlidePosition) - Math.abs(this.slideWrapperPosition));
      const distanceToPreviousSlide = Math.abs(Math.abs(this.previousSlidePosition) - Math.abs(this.slideWrapperPosition));
      return distanceToPreviousSlide < distanceToCurrentSlidePosition;
    },

    changeTestemunho(testemunho) {
      this.$emit("slideItemClicked", testemunho);
      /*this.$router.push({
        name: "detalhe",
        params:{
          id: testemunho.Name,
          postid: testemunho.ID
        }
      })*/
    },

    getUpdatedIndex(oldIndex, updatedElementsPerSlide) {
      let sl = Math.ceil(oldIndex / updatedElementsPerSlide);
      return sl == 0 ? 0 : sl - 1;
    },

    setNumberOfElementsOnSlides() {
      let body = document.getElementsByTagName("body");
      const bodyWith = body[0].clientWidth;

      if (bodyWith > IPADWIDTH && this.elementsPerSlide != 3) {
        this.elementsPerSlide = 3;
      }

      if (bodyWith < IPADWIDTH && bodyWith > IPHONEWIDTH && this.elementsPerSlide != 2) {
        this.elementsPerSlide = 2;
      }

      if (bodyWith < IPHONEWIDTH && this.elementsPerSlide != 1) {
        this.elementsPerSlide = 1;
      }
    },

    setNumberOfElementsPerSlide() {
      let body = document.getElementsByTagName("body");
      const bodyWith = body[0].clientWidth;

      if (bodyWith > IPADWIDTH && this.elementsPerSlide != 3) {
        this.elementsPerSlide = 3;
        this.initSlides();
      }

      if (bodyWith < IPADWIDTH && bodyWith > IPHONEWIDTH && this.elementsPerSlide != 2) {
        this.elementsPerSlide = 2;
        this.initSlides();
      }

      if (bodyWith < IPHONEWIDTH && this.elementsPerSlide != 1) {
        this.elementsPerSlide = 1;
        this.initSlides();
      }

      this.setSlidesPosition();
      this.equalizeSlidesHeight();
    },

    equalizeSlidesHeight() {
      this.getMaximumHeigthText();
      let maxHeigth = 0;
      this.slides.map((el, index) => {
        const elementToGetHeight = this.$refs[`sld${index}`];

        if (elementToGetHeight != null) {
          let updatedHeigth = this.$refs[`sld${index}`][0]?.offsetHeight;

          if (updatedHeigth > maxHeigth) {
            maxHeigth = updatedHeigth;
          }
        }
      });
      this.slideHeight = maxHeigth;
    },

    initSlides() {
      const itemsToSplice = [...this.items];
      const numberOfSlides = Math.ceil(this.items.length / this.elementsPerSlide);
      this.slides = new Array(numberOfSlides).fill(1).map(() => itemsToSplice.splice(0, this.elementsPerSlide)).map(el => {
        return {
          elements: el
        };
      });
      /*const numberOfElementsOnLastSlide = this.slides[numberOfSlides-1].elements.length;
      if(numberOfElementsOnLastSlide < this.elementsPerSlide){
        const a = this.items.slice(0,this.elementsPerSlide-numberOfElementsOnLastSlide)
        this.slides[numberOfSlides-1].elements = 
          [...this.slides[numberOfSlides-1].elements,...a];
      }*/
    },

    setSlidesPosition() {
      sliderWidth = this.calculateSliderWidth();
      this.slides = this.slides.map((el, index) => {
        const numberOfSlides = Math.ceil(this.items.length / this.elementsPerSlide);
        let position = 0;

        if (numberOfSlides > 1) {
          position = index < numberOfSlides - 1 ? index * sliderWidth : -sliderWidth;
        }

        return { ...el,
          position: position
        };
      });
    },

    calculateSliderWidth() {
      var style = window.getComputedStyle(document.querySelector(".paddingwrapper"), null);
      const paddingLeft = parseFloat(style.getPropertyValue("padding-left"));
      const paddingRight = parseFloat(style.getPropertyValue("padding-right"));
      return document.querySelector(".paddingwrapper").clientWidth - paddingLeft - paddingRight;
    },

    getMaximumHeigthText() {
      const nodes = document.querySelectorAll(".casosslider .testemunhoItem p");
      const items = Array.from(nodes);
      const defaultHeight = Math.max(...items.map(el => el.offsetHeight));
      nodes.forEach(el => {
        let marginbtn = defaultHeight - el.offsetHeight + 16;
        el.setAttribute("style", `margin-bottom: ${marginbtn}px`);
      });
      const personnodes = document.querySelectorAll(".casosslider .person");
      const personItems = Array.from(personnodes);
      const personDefaultHeight = Math.max(...personItems.map(el => el.offsetHeight));
      personnodes.forEach(el => {
        el.setAttribute("style", `min-height: ${personDefaultHeight}px`);
      });
    },

    setDimensions(height) {
      this.slideHeight = height;
      this.equalizeSlidesHeight();
      this.getMaximumHeigthText();
    },

    recalculatePreviousSlidePosition() {
      if (this.previousSlidePosition > this.currentSlidePosition) {
        this.slides[this.previousSlideIndex].position = this.currentSlidePosition - sliderWidth;
      }
    },

    needsToRecalculateSlidePosition() {
      return this.previousSlidePosition > this.currentSlidePosition;
    },

    slideBack() {
      if (!this.isSliding) {
        this.currentSlideIndex = this.previousSlideIndex;
        this.moveSlide(-this.currentSlidePosition);
      }
    },

    slideNext() {
      if (!this.isSliding) {
        this.calculatePositionForNextSlides();
        this.moveSlide(-this.currentSlidePosition);
      }
    },

    calculatePositionForNextSlides() {
      this.currentSlideIndex = this.nextSlideIndex;
      this.slides[this.currentSlideIndex].position = this.previousSlidePosition + sliderWidth;
    },

    moveSlide(value) {
      this.slideWrapperPosition = value;
    }

  },
  directives: {
    resize
  }
});
;// CONCATENATED MODULE: ./src/components/WebSlider.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-22.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[4]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/WebSlider.vue?vue&type=style&index=0&id=61b291c1&scoped=true&lang=scss
var WebSlidervue_type_style_index_0_id_61b291c1_scoped_true_lang_scss = __webpack_require__(745);
;// CONCATENATED MODULE: ./src/components/WebSlider.vue?vue&type=style&index=0&id=61b291c1&scoped=true&lang=scss

;// CONCATENATED MODULE: ./src/components/WebSlider.vue




;


const WebSlider_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(WebSlidervue_type_script_lang_js, [['render',render],['__scopeId',"data-v-61b291c1"]])

/* harmony default export */ var WebSlider = (WebSlider_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ComboBox.vue?vue&type=template&id=ecfbf8cc&scoped=true


const ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_withScopeId = n => ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.pushScopeId)("data-v-ecfbf8cc"), n = n(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.popScopeId)(), n);

const ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_hoisted_1 = {
  class: "option"
};

const ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_hoisted_2 = /*#__PURE__*/ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("i", {
  class: "fa fa-chevron-down"
}, null, -1));

const ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_hoisted_3 = {
  key: 0,
  class: "value"
};
const ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_hoisted_4 = {
  key: 1,
  class: "result"
};

const _hoisted_5 = /*#__PURE__*/ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("span", {
  class: "drop_linha"
}, null, -1));

const _hoisted_6 = {
  class: "drop"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "opt"
};

const _hoisted_9 = /*#__PURE__*/ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_withScopeId(() => /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("i", {
  class: "cicloremove ms-Icon ms-Icon--Cancel",
  "aria-hidden": "true"
}, null, -1));

function ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_clickOutside = (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.resolveDirective)("clickOutside");

  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("div", ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("a", {
    class: "dropdownbtn",
    "data-toggle": "grauDropDown",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.switchOption && $options.switchOption(...args))
  }, [ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_hoisted_2, $props.modelValue == null ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("span", ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)($props.defaultmsg), 1)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("span", ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_hoisted_4, (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)($props.modelValue.label), 1)), _hoisted_5]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("div", {
    class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)(["dropdown-pane", {
      'is-open': $props.isOpen
    }]),
    id: "grauDropDown",
    "data-dropdown": ""
  }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("ul", _hoisted_6, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.renderList)($props.options, option => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("li", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)({
        'active': option == $props.modelValue
      }),
      key: option.title,
      onClick: $event => $options.handleInput(option)
    }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("a", _hoisted_8, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)(option.label) + " ", 1), _hoisted_9])], 10, _hoisted_7);
  }), 128))])], 2)])), [[_directive_clickOutside, $options.clickedOutside]]);
}
;// CONCATENATED MODULE: ./src/components/ComboBox.vue?vue&type=template&id=ecfbf8cc&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ComboBox.vue?vue&type=script&lang=js
const clickOutside = {
  beforeMount: (el, binding) => {
    el.clickOutsideEvent = event => {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        binding.value();
      }
    };

    document.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted: el => {
    document.removeEventListener("click", el.clickOutsideEvent);
  }
};
/* harmony default export */ var ComboBoxvue_type_script_lang_js = ({
  name: "ComboBox",
  props: ["modelValue", "defaultmsg", "options", "isOpen"],
  emits: ["update:modelValue", "update:openCombo", "update:closeCombo", "clickOutside"],

  created() {},

  methods: {
    clickedOutside() {
      this.$emit("clickOutside");
    },

    handleInput(option) {
      const updatedOption = option != this.modelValue ? option : null;
      this.$emit('update:modelValue', updatedOption);
      this.$emit("update:closeCombo");
    },

    switchOption() {
      this.$emit("update:openCombo");
    }

  },
  directives: {
    clickOutside
  }
});
;// CONCATENATED MODULE: ./src/components/ComboBox.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/ComboBox.vue?vue&type=style&index=0&id=ecfbf8cc&scoped=true&lang=css
var ComboBoxvue_type_style_index_0_id_ecfbf8cc_scoped_true_lang_css = __webpack_require__(629);
;// CONCATENATED MODULE: ./src/components/ComboBox.vue?vue&type=style&index=0&id=ecfbf8cc&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/ComboBox.vue




;


const ComboBox_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ComboBoxvue_type_script_lang_js, [['render',ComboBoxvue_type_template_id_ecfbf8cc_scoped_true_render],['__scopeId',"data-v-ecfbf8cc"]])

/* harmony default export */ var ComboBox = (ComboBox_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/buttons/TBotao.vue?vue&type=template&id=0a20cc1c&scoped=true


const TBotaovue_type_template_id_0a20cc1c_scoped_true_withScopeId = n => (_pushScopeId("data-v-0a20cc1c"), n = n(), _popScopeId(), n);

const TBotaovue_type_template_id_0a20cc1c_scoped_true_hoisted_1 = {
  class: "botao_style"
};
function TBotaovue_type_template_id_0a20cc1c_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("div", TBotaovue_type_template_id_0a20cc1c_scoped_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("p", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.renderSlot)(_ctx.$slots, "default", {}, undefined, true)])]);
}
;// CONCATENATED MODULE: ./src/components/buttons/TBotao.vue?vue&type=template&id=0a20cc1c&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/buttons/TBotao.vue?vue&type=script&lang=js
const __default__ = {
  name: "TBotao",
  props: ["backgroundColor", "borderColor", "textColor"]
};


const __injectCSSVars__ = () => {
  (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.useCssVars)(_ctx => ({
    "50815640": _ctx.borderColor,
    "66740a82": _ctx.textColor,
    "50610ec4": _ctx.backgroundColor
  }));
};

const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props, ctx) => {
  __injectCSSVars__();

  return __setup__(props, ctx);
} : __injectCSSVars__;
/* harmony default export */ var TBotaovue_type_script_lang_js = (__default__);
;// CONCATENATED MODULE: ./src/components/buttons/TBotao.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/buttons/TBotao.vue?vue&type=style&index=0&id=0a20cc1c&scoped=true&lang=css
var TBotaovue_type_style_index_0_id_0a20cc1c_scoped_true_lang_css = __webpack_require__(660);
;// CONCATENATED MODULE: ./src/components/buttons/TBotao.vue?vue&type=style&index=0&id=0a20cc1c&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/buttons/TBotao.vue




;


const TBotao_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(TBotaovue_type_script_lang_js, [['render',TBotaovue_type_template_id_0a20cc1c_scoped_true_render],['__scopeId',"data-v-0a20cc1c"]])

/* harmony default export */ var TBotao = (TBotao_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/navigation/BreadCrumb.vue?vue&type=template&id=fdffc126&scoped=true


const BreadCrumbvue_type_template_id_fdffc126_scoped_true_withScopeId = n => (_pushScopeId("data-v-fdffc126"), n = n(), _popScopeId(), n);

const BreadCrumbvue_type_template_id_fdffc126_scoped_true_hoisted_1 = {
  "aria-label": "You are here:",
  role: "navigation"
};
const BreadCrumbvue_type_template_id_fdffc126_scoped_true_hoisted_2 = {
  class: "breadcrumbs"
};
const BreadCrumbvue_type_template_id_fdffc126_scoped_true_hoisted_3 = ["href"];
function BreadCrumbvue_type_template_id_fdffc126_scoped_true_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.resolveComponent)("router-link");

  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("nav", BreadCrumbvue_type_template_id_fdffc126_scoped_true_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementVNode)("ul", BreadCrumbvue_type_template_id_fdffc126_scoped_true_hoisted_2, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.renderList)($props.breadcrumb, crumb => {
    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("li", {
      class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeClass)({
        'onviewportnotranslate': $props.showBread
      }),
      key: crumb.ID
    }, [crumb.route == null ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createElementBlock)("a", {
      key: 0,
      style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeStyle)({
        color: $props.color
      }),
      href: crumb?.href
    }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)(crumb.text), 13, BreadCrumbvue_type_template_id_fdffc126_scoped_true_hoisted_3)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createCommentVNode)("", true), crumb.route != null ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createBlock)(_component_router_link, {
      key: 1,
      style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.normalizeStyle)({
        color: $props.color
      }),
      to: `${crumb.route.to}`
    }, {
      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.withCtx)(() => [(0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.toDisplayString)(crumb.text), 1)]),
      _: 2
    }, 1032, ["style", "to"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject.createCommentVNode)("", true)], 2);
  }), 128))])]);
}
;// CONCATENATED MODULE: ./src/components/navigation/BreadCrumb.vue?vue&type=template&id=fdffc126&scoped=true

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/navigation/BreadCrumb.vue?vue&type=script&lang=js
/* harmony default export */ var BreadCrumbvue_type_script_lang_js = ({
  props: ["breadcrumb", "showBread", "color"]
});
;// CONCATENATED MODULE: ./src/components/navigation/BreadCrumb.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-style-loader/index.js??clonedRuleSet-12.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/components/navigation/BreadCrumb.vue?vue&type=style&index=0&id=fdffc126&scoped=true&lang=css
var BreadCrumbvue_type_style_index_0_id_fdffc126_scoped_true_lang_css = __webpack_require__(975);
;// CONCATENATED MODULE: ./src/components/navigation/BreadCrumb.vue?vue&type=style&index=0&id=fdffc126&scoped=true&lang=css

;// CONCATENATED MODULE: ./src/components/navigation/BreadCrumb.vue




;


const BreadCrumb_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(BreadCrumbvue_type_script_lang_js, [['render',BreadCrumbvue_type_template_id_fdffc126_scoped_true_render],['__scopeId',"data-v-fdffc126"]])

/* harmony default export */ var BreadCrumb = (BreadCrumb_exports_);
;// CONCATENATED MODULE: ./src/index.js





;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=umaaui.common.js.map